$(document).ready(function () {
    // title inheritance is not implemented in icheck 1.* but this works
    // @see https://github.com/fronteed/icheck/issues/96
    $(document).on('ifCreated', 'input', function() {
        if (this.title) {
            $(this).parent().attr('title', this.title);
        }
    });

    parseCheckboxes();

});

$(document).on('loadFinish', function () {
    parseCheckboxes();
});

var parseCheckboxes = function () {
    $('input:not(.toggle):not(.no-ready)').iCheck({
        checkboxClass: 'checkbox-square',
        radioClass: 'radio-square',
        increaseArea: '20%' // optional
    });
    var checkboxToggle = $('input.toggle');
    $.each(checkboxToggle, function () {
        if ($(this).prop("style")['opacity'] === "") {
            $(this).iCheck({
                        checkboxClass: 'checkbox-toggle',
                        radioClass: 'radio-toggle',
                        increaseArea: '20%' // optional
                    });
        }
    });

};

window.parseCheckboxes = parseCheckboxes;